/* eslint-disable no-console */
// Configuration object for different contexts/indications
const CONFIGURATIONS = {
    asthma: {
        // Document 3 configuration
        assetPath: "asthma", // Subfolder for assets
        chapters: [
            { id: 1, startTime: 0, endTime: 7, title: "Chapter 1" },
            { id: 2, startTime: 8, endTime: 56.5, title: "Chapter 2" },
            { id: 3, startTime: 57.5, endTime: 91, title: "Chapter 3" },
            { id: 4, startTime: 92, endTime: 126, title: "Chapter 4" },
            { id: 5, startTime: 127, endTime: 157, title: "Chapter 5" },
            { id: 6, startTime: 158, endTime: 193, title: "Chapter 6" },
            { id: 7, startTime: 194, endTime: 255, title: "Chapter 7" },
            { id: 8, startTime: 256, endTime: 289, title: "Chapter 8" },
            { id: 9, startTime: 290, endTime: 337.5, title: "Chapter 9" },
            { id: 10, startTime: 338.5, endTime: 376, title: "Chapter 10" },
            { id: 11, startTime: 377, endTime: 415.5, title: "Chapter 11" },
            { id: 12, startTime: 416.5, endTime: 446, title: "Chapter 12" },
            { id: 13, startTime: 447, endTime: 479.5, title: "Chapter 13" },
            { id: 14, startTime: 480.5, endTime: 510, title: "Chapter 14" },
            { id: 15, startTime: 511, endTime: 521, title: "Chapter 15" }
        ],
        layout: {
            titlePage: {
                buttonsDirection: "d6-flex-col",
                buttonsPosition: {
                    left: "d6-left-[79%] sm:d6-left-[79%] md:d6-left-[79%] lg:d6-left-[79%]",
                    bottom: "d6-bottom-[11%]"
                },
                buttonsSize: {
                    width: "d6-w-[28%]",
                    height: "d6-h-[22%]"
                },
                buttonWidth: "d6-w-[100%]"
            },
            navigation: {
                position: "d6-bottom-[10px] sm:d6-bottom-[10px]",
                buttons: {
                    prev: "d6-w-[50px] d6-h-[50px] sm:d6-w-[50px] sm:d6-h-[50px] md:d6-w-[60px] md:d6-h-[60px] lg:d6-w-[88px] lg:d6-h-[88px]",
                    mute: "d6-w-[35px] d6-h-[35px] sm:d6-w-[35px] sm:d6-h-[35px] md:d6-w-[40px] md:d6-h-[40px] lg:d6-w-[56px] lg:d6-h-[56px]",
                    home: "d6-w-[35px] d6-h-[35px] sm:d6-w-[35px] sm:d6-h-[35px] md:d6-w-[40px] md:d6-h-[40px] lg:d6-w-[56px] lg:d6-h-[56px]",
                    playPause: "d6-w-[35px] d6-h-[35px] sm:d6-w-[35px] sm:d6-h-[35px] md:d6-w-[40px] md:d6-h-[40px] lg:d6-w-[56px] lg:d6-h-[56px]",
                    next: "d6-w-[50px] d6-h-[50px] sm:d6-w-[50px] sm:d6-h-[50px] md:d6-w-[60px] md:d6-h-[60px] lg:d6-w-[88px] lg:d6-h-[88px]"
                }
            },
            portraitOverlay: {
                alignment: "d6-items-start"
            }
        }
    },

    atopicdermatitis: {
        // Document 4 configuration (Dupixent atopicdermatitis)
        assetPath: "atopicdermatitis", // Subfolder for assets
        chapters: [
            { id: 1, startTime: 0, endTime: 7, title: "Chapter 1" },
            { id: 2, startTime: 8, endTime: 39, title: "Chapter 2" },
            { id: 3, startTime: 40, endTime: 62, title: "Chapter 3" },
            { id: 4, startTime: 63, endTime: 99, title: "Chapter 4" },
            { id: 5, startTime: 100, endTime: 125, title: "Chapter 5" },
            { id: 6, startTime: 126, endTime: 159, title: "Chapter 6" },
            { id: 7, startTime: 160, endTime: 189, title: "Chapter 7" },
            { id: 8, startTime: 190, endTime: 217, title: "Chapter 8" },
            { id: 9, startTime: 218, endTime: 268, title: "Chapter 9" },
            { id: 10, startTime: 269, endTime: 313, title: "Chapter 10" },
            { id: 11, startTime: 314, endTime: 334, title: "Chapter 11" },
            { id: 12, startTime: 335, endTime: 365, title: "Chapter 12" },
            { id: 13, startTime: 366, endTime: 394, title: "Chapter 13" },
            { id: 14, startTime: 395, endTime: 439, title: "Chapter 14" },
            { id: 15, startTime: 440, endTime: 463, title: "Chapter 15" },
            { id: 16, startTime: 464, endTime: 495, title: "Chapter 16" },
            { id: 17, startTime: 496, endTime: 512, title: "Chapter 17" }
        ],
        layout: {
            titlePage: {
                buttonsDirection: "d6-flex-row",
                buttonsPosition: {
                    left: "d6-left-[30%] sm:d6-left-[35%] md:d6-left-[33%] lg:d6-left-[30%]",
                    bottom: "d6-bottom-[6%] sm:d6-bottom-[10%]"
                },
                buttonsSize: {
                    width: "d6-w-[45%] sm:d6-w-[38%]",
                    height: "d6-h-[50%] sm:d6-h-[44%]"
                },
                buttonWidth: "d6-w-[48%]"
            },
            navigation: {
                position: "d6-bottom-[40px] sm:d6-bottom-[40px]",
                buttons: {
                    prev: "d6-w-[50px] d6-h-[50px] sm:d6-w-[50px] sm:d6-h-[50px] md:d6-w-[60px] md:d6-h-[60px] lg:d6-w-[80px] lg:d6-h-[80px]",
                    mute: "d6-w-[50px] d6-h-[50px] sm:d6-w-[50px] sm:d6-h-[50px] md:d6-w-[60px] md:d6-h-[60px] lg:d6-w-[80px] lg:d6-h-[80px]",
                    home: "d6-w-[50px] d6-h-[50px] sm:d6-w-[50px] sm:d6-h-[50px] md:d6-w-[60px] md:d6-h-[60px] lg:d6-w-[80px] lg:d6-h-[80px]",
                    playPause: "d6-w-[50px] d6-h-[50px] sm:d6-w-[50px] sm:d6-h-[50px] md:d6-w-[60px] md:d6-h-[60px] lg:d6-w-[80px] lg:d6-h-[80px]",
                    next: "d6-w-[50px] d6-h-[50px] sm:d6-w-[50px] sm:d6-h-[50px] md:d6-w-[60px] md:d6-h-[60px] lg:d6-w-[80px] lg:d6-h-[80px]"
                }
            },
            portraitOverlay: {
                alignment: "d6-items-center"
            }
        }
    }
};

/* grab data links */
const videoIsi = document.querySelector(".experience-wrapper").dataset.videoIsi;
const videoWithNarration = document.querySelector(".experience-wrapper").dataset.videoWithNarration;
const videoAmbient = document.querySelector(".experience-wrapper").dataset.videoAmbient;
const backgroundAudio = document.querySelector(".experience-wrapper").dataset.audio;

const activeConfig = getActiveConfig();

const initialState = {
    buildPath: `./.resources/sanofi-lm-dupixent/themes/sanofi-dupixent-dtc/src/img/pixi/${activeConfig.assetPath}`,
    currentView: "titlePage",
    storybook: {
        chapters: activeConfig.chapters,
        currentChapterIndex: 0,
        videoPlaying: false
    },
    transitions: {
        overlayVisible: false,
        videoPlaying: false
    },
    navigation: {
        nextEnabled: true,
        prevEnabled: false
    },
    withNarration: true
};

let state = { ...initialState };
const getState = () => state;
const setState = newState => {
    state = { ...state, ...newState };
};

const setNarrationPreference = withNarration => {
    setState({ withNarration });
};
const setView = view => {
    setState({ currentView: view });
    experience.render();
};
const setNavigationEnabled = (next, prev) => {
    setState({
        navigation: { nextEnabled: next, prevEnabled: prev }
    });
};

// Helper function to get layout config
function getLayoutConfig() {
    return getActiveConfig().layout;
}

// Get active configuration based on context
function getActiveConfig() {
    const context = document.querySelector(".experience-wrapper").dataset.indication;

    return CONFIGURATIONS[context] || CONFIGURATIONS.atopicdermatitis;
}

// Helper function to get asset path
function getAssetPath() {
    const { buildPath } = getState();
    return `${buildPath}`;
}

class GlobalNavigation {
    rootElement;
    nav;
    prevButton;
    nextButton;
    observer;
    videoEventListeners = {};
    buttonEventListeners = {};
    currentView = "titlePage";
    template() {
        const assetPath = getAssetPath();
        const layout = getLayoutConfig().navigation;

        return `
        <div id="d6-nav" class="d6-absolute d6-w-full ${layout.position} sm:d6-h-[60px] md:d6-h-[80px] lg:d6-h-[100px] d6-px-4 d6-z-50 d6-flex d6-justify-center">
          <div class="d6-flex d6-items-center d6-gap-4">
            <button id="d6-prev" class="${layout.buttons.prev} d6-relative d6-disabled:d6-opacity-50 d6-transform d6-transition-transform d6-duration-300 hover:d6-scale-105 active:d6-scale-95">
              <img src="${assetPath}/LEFT.png" alt="Previous Chapter" class="d6-w-full d6-h-full">
            </button>
            <button id="d6-mute" class="${layout.buttons.mute} d6-relative d6-disabled:d6-opacity-50 d6-transform d6-transition-transform d6-duration-300 hover:d6-scale-105 active:d6-scale-95">
              <img src="${assetPath}/MUTE.png" alt="Mute" class="d6-w-full d6-h-full">
            </button>
            <button id="d6-home" class="${layout.buttons.home} d6-relative d6-disabled:d6-opacity-50 d6-transform d6-transition-transform d6-duration-300 hover:d6-scale-105 active:d6-scale-95">
              <img src="${assetPath}/HOME.png" alt="Home" class="d6-w-full d6-h-full">
            </button>
            <button id="d6-play-pause" class="${layout.buttons.playPause} d6-relative d6-disabled:d6-opacity-50 d6-transform d6-transition-transform d6-duration-300 hover:d6-scale-105 active:d6-scale-95">
              <img src="${assetPath}/PAUSE.png" alt="Play/Pause" class="d6-w-full d6-h-full">
            </button>
            <button id="d6-next" class="${layout.buttons.next} d6-relative d6-disabled:d6-opacity-50 d6-transform d6-transition-transform d6-duration-300 hover:d6-scale-105 active:d6-scale-95">
              <img src="${assetPath}/RIGHT.png" alt="Next Chapter" class="d6-w-full d6-h-full">
            </button>
          </div>
        </div>
      `;
    }
    initialize(rootElement) {
        const nav = document.createElement("div");
        nav.innerHTML = this.template();
        const navContent = nav.firstElementChild;
        rootElement.appendChild(navContent);
        this.nav = navContent;
        this.prevButton = document.getElementById("d6-prev");
        this.nextButton = document.getElementById("d6-next");
        this.rootElement = rootElement;
        this.attachButtonEventListeners();
        this.observeViewChanges();
    }
    observeViewChanges() {
        this.observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.type === "attributes" && mutation.attributeName === "class") {
                    const target = mutation.target;
                    const viewId = target.id;
                    if (viewId && !target.classList.contains("d6-hidden") && (viewId === "storybook" || viewId === "disclaimer" || viewId === "titlePage")) {
                        this.cleanupEventListeners();
                        if (this.currentView !== viewId) {
                            this.currentView = viewId;
                            if (viewId === "storybook") {
                                this.attachStorybookEventListeners();
                            } else if (viewId === "disclaimer") {
                                this.attachDisclaimerEventListeners();
                            }
                            this.updateNavigationVisibility();
                        }
                    }
                }
            });
        });
        document.querySelectorAll(".d6-view").forEach(view => {
            this.observer?.observe(view, {
                attributes: true,
                attributeFilter: ["class"]
            });
        });
        this.updateNavigationVisibility();
    }
    updateNavigationVisibility() {
        const { currentView, storybook } = getState();
        const nav = document.getElementById("d6-nav");
        const nextButton = document.getElementById("d6-next");
        if (!nav || !nextButton) return;
        if (currentView === "titlePage") {
            nav.classList.add("d6-hidden");
            return;
        }
        nav.classList.remove("d6-hidden");
        const muteButton = document.getElementById("d6-mute");
        if (muteButton) {
            muteButton.style.display = "block";
            const videoElement = currentView === "storybook" ? document.getElementById("d6-storybook-video") : document.getElementById("d6-disclaimer-video");
            if (videoElement) {
                this.updateMuteButton(videoElement.muted);
            }
        }
        const playPauseButton = document.getElementById("d6-play-pause");
        if (playPauseButton) {
            const videoElement = currentView === "storybook" ? document.getElementById("d6-storybook-video") : document.getElementById("d6-disclaimer-video");
            if (videoElement) {
                this.updatePlayPauseButton(!videoElement.paused);
            }
        }
        const { buildPath } = getState();
        const img = nextButton?.querySelector("img");
        if (img) {
            img.src = `${buildPath}/RIGHT.png`;
            img.alt = "Next";
        }
        if (currentView === "disclaimer") {
            nextButton.style.opacity = "1";
            nextButton.style.pointerEvents = "auto";
            nextButton.classList.remove("d6-animate-bounce-gentle");
            nextButton.style.animation = "none";
            const prevButton = document.getElementById("d6-prev");
            if (prevButton) {
                prevButton.style.opacity = "1";
                prevButton.style.pointerEvents = "auto";
            }
        } else if (currentView === "storybook") {
            if (storybook.currentChapterIndex === 0) {
                nextButton.style.opacity = "0";
                nextButton.style.pointerEvents = "none";
                nextButton.classList.remove("d6-animate-bounce-gentle");
            } else {
                const videoElement = document.getElementById("d6-storybook-video");
                if (videoElement && storybook.chapters[storybook.currentChapterIndex]) {
                    const currentChapter = storybook.chapters[storybook.currentChapterIndex];
                    const isAtChapterEnd = Math.abs(videoElement.currentTime - currentChapter.endTime) < 0.1;
                    if (isAtChapterEnd || videoElement.paused) {
                        nextButton.style.opacity = "1";
                        nextButton.style.pointerEvents = "auto";
                    }
                }
            }
            const prevButton = document.getElementById("d6-prev");
            if (prevButton) {
                prevButton.style.opacity = "1";
                prevButton.style.pointerEvents = "auto";
            }
        }
    }
    // Attach common button event listeners that don't depend on the current view
    attachButtonEventListeners() {
        const muteButton = document.getElementById("d6-mute");
        if (muteButton) {
            const muteListener = this.handleMuteClick.bind(this);
            muteButton.addEventListener("click", muteListener);
            this.buttonEventListeners["mute"] = { el: muteButton, listener: muteListener };
        }
        const playPauseButton = document.getElementById("d6-play-pause");
        if (playPauseButton) {
            const playPauseListener = this.handlePlayPauseClick.bind(this);
            playPauseButton.addEventListener("click", playPauseListener);
            this.buttonEventListeners["playPause"] = { el: playPauseButton, listener: playPauseListener };
        }
        if (this.prevButton) {
            const prevListener = this.handlePrevClick.bind(this);
            this.prevButton.addEventListener("click", prevListener);
            this.buttonEventListeners["prev"] = { el: this.prevButton, listener: prevListener };
        }
        if (this.nextButton) {
            const nextListener = this.handleNextClick.bind(this);
            this.nextButton.addEventListener("click", nextListener);
            this.buttonEventListeners["next"] = { el: this.nextButton, listener: nextListener };
        }
        const homeButton = document.getElementById("d6-home");
        if (homeButton) {
            const homeListener = () => {
                window.location.reload();
            };
            homeButton.addEventListener("click", homeListener);
            this.buttonEventListeners["home"] = { el: homeButton, listener: homeListener };
        }
    }
    attachStorybookEventListeners() {
        const videoElement = document.getElementById("d6-storybook-video");
        if (!videoElement) return;
        const timeUpdateListener = () => {
            const { storybook } = getState();
            const currentTime = videoElement.currentTime;
            const currentChapter = storybook.chapters[storybook.currentChapterIndex];
            if (currentChapter && currentTime >= currentChapter.endTime) {
                const nextButton = document.getElementById("d6-next");
                if (nextButton) {
                    nextButton.style.opacity = "1";
                    nextButton.style.pointerEvents = "auto";
                }
            }
            let prevChapter2 = storybook.currentChapterIndex;
            const newChapterIndex = storybook.chapters.findIndex(chapter => currentTime >= chapter.startTime && currentTime <= chapter.endTime);
            if (newChapterIndex !== prevChapter2 && newChapterIndex !== -1) {
                prevChapter2 = newChapterIndex;
                setState({
                    storybook: {
                        ...storybook,
                        currentChapterIndex: Math.max(0, newChapterIndex),
                        videoPlaying: !videoElement.paused
                    }
                });
                requestAnimationFrame(() => this.updateNavigationVisibility());
            }
        };
        this.videoEventListeners["timeupdate"] = timeUpdateListener;
        videoElement.addEventListener("timeupdate", timeUpdateListener);
    }
    attachDisclaimerEventListeners() {
        const disclaimerVideo = document.getElementById("d6-disclaimer-video");
        if (!disclaimerVideo) return;
        const endedListener = () => {
            setView("titlePage");
        };
        this.videoEventListeners["ended"] = endedListener;
        disclaimerVideo.addEventListener("ended", endedListener);
        const nextButton = document.getElementById("d6-next");
        if (nextButton) {
            nextButton.classList.remove("d6-animate-bounce-gentle");
            nextButton.style.opacity = "1";
            nextButton.style.pointerEvents = "auto";
            nextButton.setAttribute("style", "animation: none !important; opacity: 1 !important; pointer-events: auto !important;");
            if (!document.getElementById("no-wiggle-disclaimer")) {
                const style = document.createElement("style");
                style.id = "no-wiggle-disclaimer";
                style.textContent = `
                      #disclaimer:not(.d6-hidden) ~ #d6-nav #d6-next {
                          animation: none !important;
                          transition: transform 0.3s ease !important;
                      }
                  `;
                document.head.appendChild(style);
            }
        }
        const playPauseButton = document.getElementById("d6-play-pause");
        if (playPauseButton && disclaimerVideo) {
            this.updatePlayPauseButton(!disclaimerVideo.paused);
        }
    }
    cleanupEventListeners() {
        const storybookVideo = document.getElementById("d6-storybook-video");
        if (storybookVideo) {
            Object.entries(this.videoEventListeners).forEach(([event, listener]) => {
                storybookVideo.removeEventListener(event, listener);
            });
        }
        const disclaimerVideo = document.getElementById("d6-disclaimer-video");
        if (disclaimerVideo) {
            Object.entries(this.videoEventListeners).forEach(([event, listener]) => {
                disclaimerVideo.removeEventListener(event, listener);
            });
        }
        this.videoEventListeners = {};
    }
    handleMuteClick() {
        const { currentView } = getState();
        const videoElement = currentView === "storybook" ? document.getElementById("d6-storybook-video") : document.getElementById("d6-disclaimer-video");
        if (videoElement) {
            videoElement.muted = !videoElement.muted;
            videoElement.dataset.userMuted = videoElement.muted.toString();
            if (currentView === "storybook") {
                delete videoElement.dataset.wasMuted;
            }
            this.updateMuteButton(videoElement.muted);
        }
    }
    updateMuteButton(isMuted) {
        const { buildPath } = getState();
        const muteButton = document.getElementById("d6-mute");
        if (muteButton) {
            const img = muteButton.querySelector("img");
            if (img) {
                img.src = isMuted ? `${buildPath}/MUTE.png` : `${buildPath}/UNMUTE.png`;
                img.alt = isMuted ? "Unmute" : "Mute";
            }
        }
    }
    handlePlayPauseClick() {
        const { currentView } = getState();
        const videoElement = currentView === "storybook" ? document.getElementById("d6-storybook-video") : document.getElementById("d6-disclaimer-video");
        if (videoElement) {
            if (videoElement.paused) {
                try {
                    const playPromise = videoElement.play();
                    if (playPromise !== void 0) {
                        playPromise
                            .then(() => {
                                this.updatePlayPauseButton(true);
                            })
                            .catch(error => {
                                console.error("Error playing video:", error);
                                if (error.name === "NotAllowedError") {
                                    videoElement.muted = true;
                                    this.updateMuteButton(true);
                                    videoElement
                                        .play()
                                        .then(() => {
                                            this.updatePlayPauseButton(true);
                                        })
                                        .catch(e => console.error("Failed to play even with muting:", e));
                                }
                            });
                    } else {
                        this.updatePlayPauseButton(true);
                    }
                } catch (e) {
                    console.error("Exception during play attempt:", e);
                }
            } else {
                try {
                    videoElement.pause();
                    this.updatePlayPauseButton(false);
                } catch (e) {
                    console.error("Error pausing video:", e);
                }
            }
        } else {
            console.error("No video element found for current view:", currentView);
        }
    }
    updatePlayPauseButton(isPlaying) {
        const { buildPath } = getState();
        const playPauseButton = document.getElementById("d6-play-pause");
        if (playPauseButton) {
            const img = playPauseButton.querySelector("img");
            if (img) {
                img.src = isPlaying ? `${buildPath}/PAUSE.png` : `${buildPath}/PLAY.png`;
                img.alt = isPlaying ? "Pause" : "Play";
            }
        }
    }
    async handlePrevClick() {
        const { currentView } = getState();
        if (currentView === "disclaimer") {
            const disclaimerVideo = document.getElementById("d6-disclaimer-video");
            if (disclaimerVideo) {
                disclaimerVideo.pause();
                disclaimerVideo.currentTime = 0;
            }
            setState({
                storybook: {
                    ...getState().storybook,
                    currentChapterIndex: 0
                }
            });
            setView("storybook");
            await new Promise(resolve => setTimeout(resolve, 50));
            const storyBookVideo = document.getElementById("d6-storybook-video");
            if (storyBookVideo) {
                storyBookVideo.style.opacity = "1";
                storyBookVideo.currentTime = 0;
                const prevButton = document.getElementById("d6-prev");
                if (prevButton) {
                    prevButton.style.opacity = "0.5";
                    prevButton.style.pointerEvents = "none";
                }
                const nextButton = document.getElementById("d6-next");
                if (nextButton) {
                    nextButton.style.opacity = "0.5";
                    nextButton.style.pointerEvents = "none";
                    nextButton.classList.remove("d6-animate-bounce-gentle");
                }
                try {
                    await storyBookVideo.play();
                    const playPauseButton = document.getElementById("d6-play-pause");
                    if (playPauseButton) {
                        const img = playPauseButton.querySelector("img");
                        if (img) {
                            const { buildPath } = getState();
                            img.src = `${buildPath}/PAUSE.png`;
                            img.alt = "Pause";
                        }
                    }
                } catch (error) {
                    console.error("Failed to play storybook video:", error);
                }
            }
        } else if (currentView === "storybook") {
            const videoElement = document.getElementById("d6-storybook-video");
            if (videoElement) {
                const wasPaused = videoElement.paused;
                const event = new CustomEvent("navigatePrevious");
                videoElement.dispatchEvent(event);
                if (wasPaused) {
                    setTimeout(() => {
                        videoElement
                            .play()
                            .then(() => this.updatePlayPauseButton(true))
                            .catch(e => console.error("Failed to play video after navigation:", e));
                    }, 1e3);
                }
            }
        }
    }
    handleNextClick() {
        const { currentView } = getState();
        if (currentView === "disclaimer") {
            const disclaimerVideo = document.getElementById("d6-disclaimer-video");
            if (disclaimerVideo) {
                disclaimerVideo.pause();
                disclaimerVideo.currentTime = 0;
            }
            setView("titlePage");
        } else if (currentView === "storybook") {
            const videoElement = document.getElementById("d6-storybook-video");
            if (videoElement) {
                const wasPaused = videoElement.paused;
                const event = new CustomEvent("navigateNext");
                videoElement.dispatchEvent(event);
                if (wasPaused) {
                    setTimeout(() => {
                        if (getState().currentView === "storybook") {
                            videoElement
                                .play()
                                .then(() => {
                                    this.updatePlayPauseButton(true);
                                })
                                .catch(e => {
                                    console.error("Failed to play video after navigation:", e);
                                    videoElement.muted = true;
                                    this.updateMuteButton(true);
                                    videoElement
                                        .play()
                                        .then(() => this.updatePlayPauseButton(true))
                                        .catch(err => console.error("Even muted playback failed:", err));
                                });
                        }
                    }, 1e3);
                }
            }
        }
    }
    // Cleanup on destruction
    cleanup() {
        if (this.observer) {
            this.observer.disconnect();
        }
        Object.values(this.buttonEventListeners).forEach(({ el, listener }) => {
            el.removeEventListener("click", listener);
        });
        this.cleanupEventListeners();
    }
}

class TitlePage {
    rootElement;
    view;
    audioElement;
    transitionOverlay;
    isTransitioning = false;
    template() {
        const assetPath = getAssetPath();
        const layout = getLayoutConfig().titlePage;

        return `
        <div class="d6-w-full d6-h-full d6-flex d6-items-start d6-justify-center d6-relative d6-overflow-hidden">
          <div class="d6-transition-overlay d6-absolute d6-inset-0 d6-bg-[#000] d6-opacity-0 d6-transition-opacity d6-duration-1000"></div>

          <div class="d6-relative d6-w-full d6-h-full d6-bg-[#000]">
            <img
              src="${assetPath}/background.gif"
              alt="Animated background"
              class="d6-w-full d6-h-full d6-object-contain d6-transition-opacity d6-duration-1000"
            />

            <audio id="background-music" src="${backgroundAudio}"></audio>

            <div class="d6-absolute ${layout.buttonsPosition.left} d6--translate-x-1/2 ${layout.buttonsPosition.bottom} d6-flex ${layout.buttonsDirection} d6-gap-10 ${layout.buttonsSize.width} ${layout.buttonsSize.height} d6-justify-center">
              <div
                id="with-narration"
                class="${layout.buttonWidth} d6-relative d6-cursor-pointer d6-transform d6-transition-transform d6-duration-300 hover:d6-scale-105 active:d6-scale-95"
              >
                <img
                  src="${assetPath}/with-narration.png"
                  alt="Listen with Narration"
                  class="d6-w-full d6-h-auto"
                />
              </div>

              <div
                id="without-narration"
                class="${layout.buttonWidth} d6-relative d6-cursor-pointer d6-transform d6-transition-transform d6-duration-300 hover:d6-scale-105 active:d6-scale-95"
              >
                <img
                  src="${assetPath}/without-narration.png"
                  alt="Listen without Narration"
                  class="d6-w-full d6-h-auto"
                />
              </div>
            </div>
          </div>
        </div>
      `;
    }
    initialize(rootElement) {
        const view = document.createElement("div");
        view.id = "titlePage";
        view.className = "d6-view d6-title-page";
        view.innerHTML = this.template();
        rootElement.appendChild(view);
        this.view = view;
        this.rootElement = rootElement;
        this.audioElement = view.querySelector("#background-music");
        this.transitionOverlay = view.querySelector(".d6-transition-overlay");
        this.initializeAudio();
        this.attachEventListeners();
    }
    async initializeAudio() {
        if (this.audioElement) {
            this.audioElement.volume = 0.5;
            this.audioElement.loop = true;
            this.audioElement.muted = false;
            try {
                await this.audioElement.play();
                const soundToggle = document.getElementById("sound-toggle");
                if (soundToggle) {
                    soundToggle.innerHTML = '<span class="d6-text-white">🔊</span>';
                }
            } catch (error) {
                console.log("Auto-play prevented");
            }
        }
    }
    async handleNavigation(withNarration) {
        if (this.isTransitioning) return;
        this.isTransitioning = true;
        if (this.transitionOverlay) {
            this.transitionOverlay.classList.remove("d6-opacity-0");
            this.transitionOverlay.classList.add("d6-opacity-100");
        }
        if (this.audioElement) {
            const fadeOutDuration = 1e3;
            const steps = 20;
            const stepTime = fadeOutDuration / steps;
            const volumeStep = this.audioElement.volume / steps;
            for (let i = steps; i > 0; i--) {
                this.audioElement.volume = volumeStep * i;
                await new Promise(resolve => setTimeout(resolve, stepTime));
            }
            this.audioElement.pause();
        }
        await setNarrationPreference(withNarration);
        await new Promise(resolve => setTimeout(resolve, 100));
        setView("storybook");
    }
    toggleMute = () => {
        if (!this.audioElement) return;
        if (this.audioElement.paused) {
            this.audioElement.play();
            const muteButton = document.getElementById("sound-toggle");
            if (muteButton) muteButton.innerHTML = '<span class="d6-text-white">🔊</span>';
        } else {
            this.audioElement.pause();
            const muteButton = document.getElementById("sound-toggle");
            if (muteButton) muteButton.innerHTML = '<span class="d6-text-white">🔇</span>';
        }
    };
    attachEventListeners() {
        const soundToggle = document.getElementById("sound-toggle");
        const withNarrationButton = document.getElementById("with-narration");
        const withoutNarrationButton = document.getElementById("without-narration");
        soundToggle?.addEventListener("click", () => this.toggleMute());
        withNarrationButton?.addEventListener("click", () => this.handleNavigation(true));
        withoutNarrationButton?.addEventListener("click", () => this.handleNavigation(false));
    }
    reset() {
        if (this.audioElement) {
            this.audioElement.currentTime = 0;
            this.audioElement.volume = 0.5;
            this.audioElement.muted = false;
            this.audioElement.play().catch(() => console.log("Auto-play prevented on reset"));
        }
        this.isTransitioning = false;
        if (this.transitionOverlay) {
            this.transitionOverlay.classList.add("d6-opacity-0");
            this.transitionOverlay.classList.remove("d6-opacity-100");
        }
    }
    // Cleanup method to be called when unmounting
    cleanup() {
        if (this.audioElement) {
            this.audioElement.pause();
            this.audioElement.currentTime = 0;
        }
        const soundToggle = document.getElementById("sound-toggle");
        const withNarrationButton = document.getElementById("with-narration");
        const withoutNarrationButton = document.getElementById("without-narration");
        if (soundToggle) soundToggle.replaceWith(soundToggle.cloneNode(true));
        if (withNarrationButton) withNarrationButton.replaceWith(withNarrationButton.cloneNode(true));
        if (withoutNarrationButton) withoutNarrationButton.replaceWith(withoutNarrationButton.cloneNode(true));
    }
}

class Storybook {
    rootElement;
    view;
    videoElement;
    isTransitioning = false;
    opacity = 1;
    isPlaying = false;
    boundEventHandlers = {};
    template() {
        const { withNarration } = getState();
        const videoSource = withNarration ? `${videoWithNarration}` : `${videoAmbient}`;
        return `
              <div class="d6-relative d6-w-full">
                  <div class="d6-relative d6-bg-[#000]">
                      <video id="d6-storybook-video"
                      class="d6-w-full d6-h-full d6-object-contain d6-transition-opacity d6-duration-300"
                      playsinline
                      webkit-playsinline
                      >
                          <source src="${videoSource}" type="video/mp4">
                      </video>
                  </div>
              </div>
          `;
    }
    initialize(rootElement) {
        const view = document.createElement("div");
        view.id = "storybook";
        view.className = "d6-view d6-storybook";
        view.innerHTML = this.template();
        const existingView = document.getElementById("storybook");
        if (existingView) {
            existingView.remove();
        }
        rootElement.appendChild(view);
        this.videoElement = document.getElementById("d6-storybook-video");
        this.view = view;
        this.rootElement = rootElement;
        if (this.videoElement) {
            this.videoElement.muted = false;
        }
        this.attachEventListeners();
    }
    reinitialize() {
        if (!this.rootElement || !this.view) return;
        this.cleanup();
        const { storybook } = getState();
        const currentChapterIndex = storybook.currentChapterIndex;
        this.view.innerHTML = this.template();
        this.videoElement = document.getElementById("d6-storybook-video");
        this.attachEventListeners();
        if (this.videoElement && currentChapterIndex < storybook.chapters.length) {
            const targetChapter = storybook.chapters[currentChapterIndex];
            if (targetChapter) {
                this.videoElement.currentTime = targetChapter.startTime;
            }
        }
    }
    attachEventListeners() {
        if (this.videoElement) {
            this.videoElement.addEventListener("timeupdate", () => {
                this.handleTimeUpdate();
            });
            this.videoElement.addEventListener("ended", () => {
                this.handleVideoEnded();
            });
            this.videoElement.addEventListener("navigateNext", () => {
                this.navigateToNext();
            });
            this.videoElement.addEventListener("navigatePrevious", () => {
                this.navigateToPrevious();
            });
            this.videoElement.addEventListener("navigateFirst", () => {
                this.jumpToChapter(0);
            });
            this.videoElement.addEventListener("navigateLast", () => {
                const { storybook } = getState();
                this.jumpToChapter(storybook.chapters.length - 1);
            });
        }
        this.boundEventHandlers = {
            timeupdate: this.handleTimeUpdate.bind(this),
            ended: this.handleVideoEnded.bind(this),
            navigateNext: () => this.navigateToNext(),
            navigatePrevious: () => this.navigateToPrevious(),
            navigateFirst: () => this.jumpToChapter(0),
            navigateLast: () => {
                const { storybook } = getState();
                this.jumpToChapter(storybook.chapters.length - 1);
            }
        };
        Object.entries(this.boundEventHandlers).forEach(([event, handler]) => {
            this.videoElement?.addEventListener(event, handler);
        });
    }
    async fadeOut() {
        this.isTransitioning = true;
        const steps = 60;
        const fadeOutDuration = 500;
        const stepDuration = fadeOutDuration / steps;
        if (this.videoElement && !this.videoElement.paused) {
            for (let i = steps; i >= 0; i--) {
                const value = i / steps;
                this.opacity = value;
                if (this.videoElement) {
                    this.videoElement.style.opacity = value.toString();
                    this.videoElement.volume = value;
                }
                await new Promise(resolve => setTimeout(resolve, stepDuration));
            }
        }
        this.opacity = 0;
        if (this.videoElement) {
            this.videoElement.style.opacity = "0";
            this.videoElement.volume = 0;
        }
    }
    async fadeIn() {
        const steps = 60;
        const fadeInDuration = 500;
        const stepDuration = fadeInDuration / steps;
        this.opacity = 0;
        if (this.videoElement) {
            this.videoElement.style.opacity = "0";
            this.videoElement.volume = 0;
        }
        for (let i = 0; i <= steps; i++) {
            const value = i / steps;
            this.opacity = value;
            if (this.videoElement) {
                this.videoElement.style.opacity = value.toString();
                this.videoElement.volume = value;
            }
            await new Promise(resolve => setTimeout(resolve, stepDuration));
        }
        this.opacity = 1;
        if (this.videoElement) {
            this.videoElement.style.opacity = "1";
            this.videoElement.volume = 1;
        }
        this.isTransitioning = false;
    }
    togglePlay() {
        if (!this.videoElement || this.isTransitioning) return;
        if (this.isPlaying) {
            this.videoElement.pause();
        } else {
            this.videoElement.play();
        }
        this.isPlaying = !this.isPlaying;
        this.updatePlayPauseButton();
    }
    toggleMute() {
        if (!this.videoElement || this.isTransitioning) return;
        this.videoElement.muted = !this.videoElement.muted;
        this.updateMuteButton();
    }
    updatePlayPauseButton() {
        const { buildPath } = getState();
        const button = document.getElementById("d6-play-pause");
        if (button) {
            const img = button.querySelector("img");
            if (img) {
                img.src = this.isPlaying ? `${buildPath}/PAUSE.png` : `${buildPath}/PLAY.png`;
                img.alt = this.isPlaying ? "Pause" : "Play";
            }
        }
    }
    updateMuteButton() {
        const { buildPath } = getState();
        const button = document.getElementById("d6-mute");
        if (button && this.videoElement) {
            const img = button.querySelector("img");
            if (img) {
                img.src = this.videoElement.muted ? `${buildPath}/MUTE.png` : `${buildPath}/UNMUTE.png`;
                img.alt = this.videoElement.muted ? "Unmute" : "Mute";
            }
        }
    }
    isChapterBoundary(time) {
        const { storybook } = getState();
        const currentChapter = storybook.chapters[storybook.currentChapterIndex];
        return currentChapter && Math.abs(time - currentChapter.endTime) < 0.1;
    }
    handleTimeUpdate() {
        if (!this.videoElement) return;
        const currentTime = this.videoElement.currentTime;
        const { storybook } = getState();
        const currentChapter = storybook.chapters[storybook.currentChapterIndex];
        storybook.currentChapterIndex === storybook.chapters.length - 1;
        if (currentChapter && currentTime >= currentChapter.endTime - 0.5) {
            const wasUserMuted = this.videoElement.muted;
            if (!wasUserMuted) {
                this.videoElement.dataset.wasMuted = "false";
            }
            this.videoElement.muted = true;
            this.videoElement.pause();
            this.isPlaying = false;
            this.updatePlayPauseButton();
            this.videoElement.currentTime = currentChapter.endTime - 0.05;
            const nextButton = document.getElementById("d6-next");
            if (nextButton) {
                requestAnimationFrame(() => {
                    nextButton.style.opacity = "1";
                    nextButton.style.pointerEvents = "auto";
                    nextButton.classList.add("d6-animate-bounce-gentle");
                });
            }
            return;
        } else if (storybook.currentChapterIndex === 0 && currentTime < currentChapter.endTime - 0.5) {
            const nextButton = document.getElementById("d6-next");
            if (nextButton) {
                nextButton.style.opacity = "0.5";
                nextButton.style.pointerEvents = "none";
                nextButton.classList.remove("d6-animate-bounce-gentle");
            }
        }
        const newChapterIndex = storybook.chapters.findIndex(chapter => currentTime >= chapter.startTime && currentTime < chapter.endTime);
        if (newChapterIndex !== -1 && newChapterIndex !== storybook.currentChapterIndex) {
            setState({
                storybook: {
                    ...storybook,
                    currentChapterIndex: newChapterIndex,
                    videoPlaying: !this.videoElement.paused
                }
            });
        }
    }
    stopNextButtonAnimation() {
        const nextButton = document.getElementById("d6-next");
        if (nextButton) {
            nextButton.classList.remove("d6-animate-bounce-gentle");
        }
    }
    updateNavigation() {
        const { storybook } = getState();
        const isAtFirstChapter = storybook.currentChapterIndex === 0;
        setNavigationEnabled(true, !isAtFirstChapter);
        const prevButton = document.getElementById("d6-prev");
        if (prevButton) {
            prevButton.style.opacity = "1";
            prevButton.style.pointerEvents = "auto";
        }
        const nextButton = document.getElementById("d6-next");
        if (nextButton && this.videoElement) {
            const { storybook: storybook2 } = getState();
            const currentChapter = storybook2.chapters[storybook2.currentChapterIndex];
            const isAtChapterEnd = Math.abs(this.videoElement.currentTime - currentChapter.endTime) < 0.1;
            if (isAtChapterEnd) {
                nextButton.style.opacity = "1";
                nextButton.style.pointerEvents = "auto";
            }
        }
    }
    async navigateToNext() {
        if (this.isTransitioning || !this.videoElement) return;
        const userMuted = this.videoElement.dataset.userMuted === "true";
        this.stopNextButtonAnimation();
        const nextButton = document.getElementById("d6-next");
        const { storybook } = getState();
        const isAtLastChapter = storybook.currentChapterIndex === storybook.chapters.length - 1;
        const currentChapter = storybook.chapters[storybook.currentChapterIndex];
        if (isAtLastChapter && Math.abs(this.videoElement.currentTime - currentChapter.endTime) < 0.5) {
            if (nextButton) {
                nextButton.style.transition = "none";
                nextButton.classList.remove("d6-animate-bounce-gentle");
                nextButton.style.opacity = "0.5";
                nextButton.style.pointerEvents = "none";
                void nextButton.offsetWidth;
                nextButton.style.transition = "";
            }
            const playPauseButton = document.getElementById("d6-play-pause");
            if (playPauseButton) {
                const img = playPauseButton.querySelector("img");
                if (img) {
                    const { buildPath } = getState();
                    img.src = `${buildPath}/PAUSE.png`;
                    img.alt = "Pause";
                }
            }
            await this.fadeOut();
            setView("disclaimer");
            return;
        }
        await this.jumpToChapter(storybook.currentChapterIndex + 1);
        await new Promise(resolve => setTimeout(resolve, 500));
        this.videoElement.muted = userMuted;
        if (userMuted) {
            this.videoElement.dataset.userMuted = "true";
        }
        this.updateMuteButton();
        try {
            await this.videoElement.play();
            this.isPlaying = true;
            this.updatePlayPauseButton();
            this.stopNextButtonAnimation();
        } catch (error) {
            console.error("Failed to play after navigation:", error);
            if (!this.videoElement.muted) {
                this.videoElement.muted = true;
                this.updateMuteButton();
                try {
                    await this.videoElement.play();
                    this.isPlaying = true;
                    this.updatePlayPauseButton();
                    this.stopNextButtonAnimation();
                } catch (e) {
                    console.error("Muted playback also failed:", e);
                }
            }
        }
    }
    async navigateToPrevious() {
        if (this.isTransitioning || !this.videoElement) return;
        this.stopNextButtonAnimation();
        const { storybook } = getState();
        const isAtFirstChapter = storybook.currentChapterIndex === 0;
        if (isAtFirstChapter) {
            window.location.reload();
        } else {
            const prevButton = document.getElementById("d6-prev");
            if (prevButton) {
                prevButton.style.opacity = "1";
                prevButton.style.pointerEvents = "auto";
            }
            await this.jumpToChapter(storybook.currentChapterIndex - 1);
            if (!this.isTransitioning) {
                await new Promise(resolve => setTimeout(resolve, 300));
                try {
                    await this.videoElement.play();
                    this.isPlaying = true;
                    this.updatePlayPauseButton();
                } catch (error) {
                    console.error("Failed to play after navigation:", error);
                    if (!this.videoElement.muted) {
                        this.videoElement.muted = true;
                        try {
                            await this.videoElement.play();
                            this.isPlaying = true;
                            this.updatePlayPauseButton();
                        } catch (e) {
                            console.error("Muted playback also failed:", e);
                        }
                    }
                }
            }
        }
    }
    checkChapterBoundary() {
        if (!this.videoElement) return;
        const { storybook } = getState();
        const currentChapter = storybook.chapters[storybook.currentChapterIndex];
        const currentTime = this.videoElement.currentTime;
        if (currentChapter && currentTime >= currentChapter.endTime - 0.05) {
            const wasMuted = this.videoElement.muted;
            this.videoElement.muted = true;
            this.videoElement.pause();
            this.isPlaying = false;
            this.updatePlayPauseButton();
            this.videoElement.currentTime = currentChapter.endTime - 0.05;
            this.videoElement.dataset.wasMuted = wasMuted.toString();
        }
    }
    async jumpToChapter(index) {
        const { storybook } = getState();
        const chapter = storybook.chapters[index];
        if (!chapter || !this.videoElement || this.isTransitioning) return;
        this.stopNextButtonAnimation();
        const wasManuallyMuted = this.videoElement.dataset.userMuted === "true";
        this.isTransitioning = true;
        if (!this.videoElement.paused) {
            this.videoElement.pause();
        }
        await this.fadeOut();
        await new Promise(resolve => setTimeout(resolve, 300));
        this.videoElement.currentTime = chapter.startTime;
        setState({
            storybook: {
                ...storybook,
                currentChapterIndex: index
            }
        });
        this.videoElement.muted = wasManuallyMuted;
        await new Promise(resolve => setTimeout(resolve, 300));
        await this.fadeIn();
        this.isTransitioning = false;
        this.updateNavigation();
        this.updateMuteButton();
    }
    handleVideoEnded() {
        const { storybook } = getState();
        const isLastChapter = storybook.currentChapterIndex === storybook.chapters.length - 1;
        if (!isLastChapter) {
            this.isPlaying = false;
            this.updatePlayPauseButton();
            setView("disclaimer");
        }
    }
    async fadeInAudio() {
        if (!this.videoElement) return;
        const steps = 60;
        const fadeInDuration = 500;
        const stepDuration = fadeInDuration / steps;
        for (let i = 0; i <= steps; i++) {
            const value = i / steps;
            this.videoElement.volume = value;
            await new Promise(resolve => setTimeout(resolve, stepDuration));
        }
    }
    async fadeOutAudio() {
        if (!this.videoElement) return;
        const steps = 60;
        const fadeOutDuration = 500;
        const stepDuration = fadeOutDuration / steps;
        for (let i = steps; i >= 0; i--) {
            const value = i / steps;
            this.videoElement.volume = value;
            await new Promise(resolve => setTimeout(resolve, stepDuration));
        }
    }
    async play() {
        const { storybook } = getState();
        if (!this.videoElement) return;
        if (this.videoElement.dataset.userMuted !== "true") {
            this.videoElement.muted = false;
        }
        delete this.videoElement.dataset.wasMuted;
        this.videoElement.style.opacity = "1";
        this.opacity = 1;
        this.updateMuteButton();
        const currentChapter = storybook.chapters[storybook.currentChapterIndex];
        if (currentChapter) {
            if (this.videoElement.currentTime >= currentChapter.endTime - 0.1) {
                this.videoElement.currentTime = currentChapter.endTime - 0.05;
                const nextButton = document.getElementById("d6-next");
                if (nextButton) {
                    nextButton.style.opacity = "1";
                    nextButton.style.pointerEvents = "auto";
                }
                return;
            }
            try {
                await this.videoElement.play();
                this.isPlaying = true;
                this.updatePlayPauseButton();
                const boundaryCheck = setInterval(() => {
                    this.checkChapterBoundary();
                    if (!this.isPlaying) {
                        clearInterval(boundaryCheck);
                    }
                }, 100);
            } catch (error) {
                console.error("Play failed:", error);
                if (!this.videoElement.muted) {
                    this.videoElement.muted = true;
                    this.updateMuteButton();
                    try {
                        await this.videoElement.play();
                        this.isPlaying = true;
                        this.updatePlayPauseButton();
                    } catch (secondError) {
                        console.error("Muted play failed:", secondError);
                    }
                }
            }
        }
    }
    async stop() {
        if (!this.videoElement) return;
        await this.fadeOutAudio();
        this.videoElement.pause();
        this.videoElement.currentTime = 0;
        this.isPlaying = false;
        this.updatePlayPauseButton();
        this.cleanup();
    }
    cleanup() {
        if (!this.videoElement) return;
        const nextButton = document.getElementById("d6-next");
        if (nextButton) {
            nextButton.style.opacity = "0.5";
            nextButton.style.pointerEvents = "none";
            nextButton.classList.remove("d6-animate-bounce-gentle");
        }
        Object.entries(this.boundEventHandlers).forEach(([event, handler]) => {
            this.videoElement?.removeEventListener(event, handler);
        });
        this.isPlaying = false;
        this.isTransitioning = false;
        this.opacity = 1;
    }
}

class Disclaimer {
    rootElement;
    view;
    videoElement;
    isPlaying = false;
    init = true;
    template() {
        return `
              <div class="d6-relative d6-w-full">
                  <div class="d6-relative d6-bg-[#000]">
                      <video id="d6-disclaimer-video"
                      class="d6-w-full d6-h-full d6-object-contain d6-transition-opacity d6-duration-300"
                      playsinline
                      webkit-playsinline
                      >
                          <source src="${videoIsi}" type="video/mp4">
                      </video>
                  </div>
              </div>
          `;
    }
    initialize(rootElement) {
        const { buildPath } = getState();
        const view = document.createElement("div");
        view.id = "disclaimer";
        view.className = "d6-view disclaimer d6-hidden";
        view.innerHTML = this.template();
        rootElement.appendChild(view);
        this.videoElement = document.getElementById("d6-disclaimer-video");
        this.view = view;
        this.rootElement = rootElement;
        const nextButton = document.getElementById("d6-next");
        if (nextButton) {
            nextButton.style.opacity = "0.5";
            nextButton.style.pointerEvents = "none";
            nextButton.classList.remove("d6-animate-bounce-gentle");
            const img = nextButton.querySelector("img");
            if (img) {
                img.src = `${buildPath}/HOME.png`;
            }
        }
        const playPauseButton = document.getElementById("d6-play-pause");
        if (playPauseButton) {
            const img = playPauseButton.querySelector("img");
            if (img) {
                img.src = `${buildPath}/PAUSE.png`;
                img.alt = "Pause";
            }
        }
        const { withNarration } = getState();
        if (this.videoElement) {
            this.videoElement.muted = !withNarration;
        }
        this.attachEventListeners();
    }
    updateNavigationButtons() {
        const { buildPath } = getState();
        const nextButton = document.getElementById("d6-next");
        if (nextButton) {
            const img = nextButton.querySelector("img");
            if (img) {
                img.src = `${buildPath}/HOME.png`;
                img.alt = "Return to Home";
            }
            nextButton.style.opacity = "1";
            nextButton.style.pointerEvents = "auto";
        }
    }
    attachEventListeners() {
        if (this.videoElement) {
            this.videoElement.addEventListener("ended", () => {
                this.handleVideoEnded();
            });
            this.videoElement.addEventListener("navigateNext", () => {
                setView("titlePage");
            });
            this.videoElement.addEventListener("navigatePrevious", () => {
                const { storybook } = getState();
                setState({
                    storybook: {
                        ...storybook,
                        currentChapterIndex: 0
                    }
                });
                setView("storybook");
            });
            this.videoElement.addEventListener("loadeddata", () => {
                const playPauseButton2 = document.getElementById("d6-play-pause");
                if (playPauseButton2) {
                    const img = playPauseButton2.querySelector("img");
                    if (img) {
                        const { buildPath } = getState();
                        img.src = `${buildPath}/PAUSE.png`;
                        img.alt = "Pause";
                    }
                }
            });
            this.videoElement.addEventListener("play", () => {
                const { buildPath } = getState();
                const playPauseButton2 = document.getElementById("d6-play-pause");
                if (playPauseButton2) {
                    const img = playPauseButton2.querySelector("img");
                    if (img) {
                        img.src = `${buildPath}/PAUSE.png`;
                        img.alt = "Pause";
                    }
                }
            });
            const playPauseButton = document.getElementById("d6-play-pause");
            if (playPauseButton) {
                playPauseButton.addEventListener("click", () => this.togglePlayPause());
            }
            const muteButton = document.getElementById("d6-mute");
            if (muteButton) {
                muteButton.addEventListener("click", () => this.toggleMute());
            }
        }
    }
    togglePlayPause() {
        if (!this.videoElement) return;
        if (this.videoElement.paused) {
            this.videoElement.play();
        } else {
            this.videoElement.pause();
        }
        this.isPlaying = !this.videoElement.paused;
        this.updatePlayPauseButton();
    }
    toggleMute() {
        if (!this.videoElement) return;
        this.videoElement.muted = !this.videoElement.muted;
        this.updateMuteButton();
    }
    updatePlayPauseButton() {
        const { buildPath } = getState();
        const playPauseButton = document.getElementById("d6-play-pause");
        if (playPauseButton) {
            const img = playPauseButton.querySelector("img");
            if (img) {
                img.src = this.isPlaying ? `${buildPath}/PAUSE.png` : `${buildPath}/PLAY.png`;
                img.alt = this.isPlaying ? "Pause" : "Play";
            }
        }
    }
    updateMuteButton() {
        const { buildPath } = getState();
        const muteButton = document.getElementById("d6-mute");
        if (muteButton && this.videoElement) {
            const img = muteButton.querySelector("img");
            if (img) {
                img.src = this.videoElement.muted ? `${buildPath}/MUTE.png` : `${buildPath}/UNMUTE.png`;
                img.alt = this.videoElement.muted ? "Unmute" : "Mute";
            }
        }
    }
    handleVideoEnded() {
        this.stop();
        setView("titlePage");
    }
    play() {
        if (!this.videoElement) return;
        const { withNarration } = getState();
        this.videoElement.muted = !withNarration;
        this.videoElement.play().then(() => {
            this.isPlaying = true;
            this.updatePlayPauseButton();
        });
    }
    stop() {
        if (!this.videoElement) return;
        this.videoElement.pause();
        this.videoElement.currentTime = 0;
        this.videoElement.muted = true;
    }
}

class PortraitModeOverlay {
    rootElement;
    overlay;
    template() {
        const assetPath = getAssetPath();
        const layout = getLayoutConfig().portraitOverlay;

        return `
        <div class="d6-portrait-overlay d6-fixed d6-inset-0 d6-z-50 d6-bg-black d6-hidden d6-flex ${layout.alignment} d6-justify-center d6-px-4">
          <div class="d6-w-full d6-max-w-md d6-text-center">
            <img
              src="${assetPath}/PORTRAIT.png"
              alt="Please rotate your device"
              class="d6-w-full d6-h-auto"
            />
          </div>
        </div>
      `;
    }
    initialize(rootElement) {
        const overlay = document.createElement("div");
        overlay.innerHTML = this.template();
        const overlayContent = overlay.firstElementChild;
        rootElement.appendChild(overlayContent);
        this.overlay = overlayContent;
        this.rootElement = rootElement;
        this.checkOrientation();
        window.addEventListener("resize", this.checkOrientation.bind(this));
    }
    checkOrientation() {
        if (!this.overlay) return;
        const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        const isPortrait = window.innerHeight > window.innerWidth;
        if (isMobile && isPortrait) {
            this.overlay.classList.remove("d6-hidden");
        } else {
            this.overlay.classList.add("d6-hidden");
        }
    }
    // Cleanup method
    cleanup() {
        window.removeEventListener("resize", this.checkOrientation.bind(this));
    }
}

class ExperienceObject {
    rootElement;
    globalNavigation;
    portraitOverlay;
    views;
    constructor() {
        this.views = {
            titlePage: new TitlePage(),
            storybook: new Storybook(),
            disclaimer: new Disclaimer()
        };
    }
    initialize(rootElement) {
        rootElement.classList.add("d6-experience");
        rootElement.innerHTML = "";
        this.rootElement = rootElement;
        this.initializeViews();
        this.initializeNavigation();
        setView("titlePage");
        this.updateNavigationVisibility("titlePage");
        this.portraitOverlay = new PortraitModeOverlay();
        this.portraitOverlay.initialize(rootElement);
    }
    initializeNavigation() {
        this.globalNavigation = new GlobalNavigation();
        this.globalNavigation.initialize(this.rootElement);
    }
    initializeViews() {
        this.views.titlePage.initialize(this.rootElement);
        this.views.storybook.initialize(this.rootElement);
        this.views.disclaimer.initialize(this.rootElement);
    }
    updateNavigationVisibility(currentView) {
        const nav = document.getElementById("d6-nav");
        if (nav) {
            if (currentView === "titlePage") {
                nav.classList.add("d6-hidden");
            } else {
                nav.classList.remove("d6-hidden");
                const nextButton = document.getElementById("d6-next");
                if (nextButton) {
                    if (currentView === "disclaimer") {
                        this.views.storybook.cleanup();
                        nextButton.style.opacity = "0";
                        nextButton.style.pointerEvents = "none";
                    } else {
                        nextButton.style.opacity = "1";
                        nextButton.style.pointerEvents = "auto";
                    }
                }
            }
        }
    }
    render() {
        const { currentView } = getState();
        document.querySelectorAll(".d6-view").forEach(el => {
            el.classList.add("d6-hidden");
        });
        if (currentView === "storybook") {
            this.views.storybook.reinitialize();
        }
        document.getElementById(currentView)?.classList.remove("d6-hidden");
        if (currentView === "titlePage") {
            this.views.titlePage.reset();
        }
        this.updateNavigationVisibility(currentView);
        if (currentView === "storybook") {
            this.views.disclaimer.stop();
            this.views.storybook.play();
        } else if (currentView === "disclaimer") {
            setTimeout(() => {
                this.views.storybook.stop().then(() => this.views.disclaimer.play());
            }, 100);
        }
    }
}

class ResponsiveWrapper {
    rootElement;
    scale = 1;
    isLandscape = false;
    resizeObserver;
    initialize(rootElement) {
        this.rootElement = rootElement;
        this.setupWrapper();
        this.handleResize = this.handleResize.bind(this);
        this.handleResize();
        this.resizeObserver = new ResizeObserver(this.handleResize);
        this.resizeObserver.observe(document.documentElement);
        window.addEventListener("orientationchange", this.handleResize);
    }
    setupWrapper() {
        if (!this.rootElement) return;
        this.rootElement.style.width = "100%";
        this.rootElement.style.maxWidth = "1336px";
        this.rootElement.style.aspectRatio = "1.65/1";
        this.rootElement.style.position = "relative";
        this.rootElement.style.transition = "transform 0.3s ease";
        this.rootElement.classList.add(
            "d6-w-full",
            // 'd6-h-screen',
            "d6-flex",
            "d6-items-center",
            "d6-justify-center",
            "d6-bg-black",
            "d6-overflow-hidden"
        );
    }
    handleResize() {
        if (!this.rootElement) return;
        this.isLandscape = window.innerWidth > window.innerHeight;
        if (this.isLandscape && window.innerHeight < 600) {
            const targetHeight = 375;
            this.scale = Math.min((window.outerHeight * 0.9) / targetHeight, 1);
        } else {
            this.scale = 1;
        }
        this.rootElement.style.transform = `scale(${this.scale})`;
        if (this.isLandscape) {
            this.rootElement.classList.add("d6-max-h-full");
        } else {
            this.rootElement.classList.remove("d6-max-h-full");
        }
    }
    cleanup() {
        window.removeEventListener("orientationchange", this.handleResize);
        this.resizeObserver?.disconnect();
    }
}

const experience = new ExperienceObject();
const wrapper = new ResponsiveWrapper();
const initialize = rootElementId => {
    const root = document.getElementById(rootElementId);
    if (!root) {
        console.error(`Element with ID ${rootElementId} not found.`);
        return;
    }
    wrapper.initialize(root);
    experience.initialize(root);
};
const main = { initialize };

export { main as default, experience, initialize, wrapper };
